import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { IDomainsSlice, TDomainCategory } from "@/redux/slices/domains/types";

type SearchDomainProps = {
  search: string;
  category?: TDomainCategory;
};

export const searchDomains = createAsyncThunk(
  "domains/searchNumbers",
  async ({ search, category }: SearchDomainProps) => {
    const response = await axios({
      method: "POST",
      url: "/api/domain-names/search",
      data: {
        search,
        category,
      },
    });

    return response.data;
  }
);

const pending = (state: IDomainsSlice, { meta: { arg } }) => {
  state.search = {
    ...state.search,
    category: arg.category,
    value: arg.search,
    loading: true,
    results: {
      available: [],
      unavailable: [],
    },
  };
};

const fulfilled = (state: IDomainsSlice, { payload }) => {
  state.search = {
    ...state.search,
    loading: false,
    results: payload,
  };
};

const rejected = (state: IDomainsSlice) => {
  state.search = {
    ...state.search,
    loading: false,
    results: {
      available: [],
      unavailable: [],
      errorMessage: "Something went wrong",
    },
  };
};

export default {
  action: searchDomains,
  pending,
  fulfilled,
  rejected,
};
